<template>
  <Preloader v-if="loading" />
  <VRow v-else-if="errorMessage" no-gutters>
    <VCol cols="12" class="text-center">
      {{ errorMessage }}
    </VCol>
  </VRow>
  <div v-else>
    <VResponsive :aspect-ratio="16/9">
      <InterviewPlayer
        v-if="interview && vacancy.script.questions.length > 0"
        v-model="question"
        :interview="interview"
        @expanded="$emit('expanded', $event)"
        :interviewer="vacancy.script.interviewer"
        :questions="interviewTimestampsFiltered"
        :omit-interviewer-questions="omitInterviewerQuestions"
        :poster="poster"
        :are-questions-equal="areQuestionsEqual"
        @update:omitInterviewerQuestions="updateOmitInterviewerQuestions"
        @play.once="interviewPlayed"
      />
    </VResponsive>
  </div>
</template>

<script>
import InterviewPlayer from '@huntica/huntica-interview-module/src/components/InterviewPlayer.vue';
import { interviewImageType, timestampTypes } from '@/enums';
import Preloader from '../Preloader.vue';
import ValidationMixin from '../../mixins/ValidationMixin';
import { response } from '../../orm/functions';
import Interview from '../../orm/models/Interview/Interview';

export default {
  name: 'CandidateInterviewVirtual',
  components: { Preloader, InterviewPlayer },
  mixins: [ValidationMixin],
  props: {
    vacancy: {
      type: Object,
      required: true,
    },
    candidate: {
      type: Object,
      required: true,
    },
    areQuestionsEqual: {
      type: Boolean,
      required: true,
      default: true,
    },
  },
  data() {
    return {
      loading: false,
      omitInterviewerQuestions: false,
      interview: { ...this.candidate.interview },
    };
  },
  computed: {
    question: {
      get() {
        return this.$store.state.candidatePage.activeQuestion;
      },
      set(value) {
        this.$store.commit('candidatePage/setActiveQuestion', value);
      },
    },
    poster() {
      const poster = this.interview.images.find((p) => p.type === interviewImageType.H296);
      if (poster) {
        if (poster.url.indexOf('media-new')) {
          return poster.url.replace('h296.jpg', 'w300.jpg');
        }

        return poster.url;
      }

      return null;
    },
    interviewTimestampsFiltered() {
      if (this.areQuestionsEqual) {
        return this.vacancy.script.questions;
      }

      return this.interview.timestamps
        .filter((t) => t.type === timestampTypes.ANSWERING)
        .map((t) => ({
          id: t.questionId,
          questionId: null,
          type: t.questionType,
          file: null,
          question: t.questionText,
          interviewerId: null,
          duration: null,
          startTime: t.startTime,
          speechStopTime: t.stopTime,
          stopTime: null,
          uuid: null,
        }));
    },
  },
  mounted() {
    if (!this.areQuestionsEqual) {
      this.updateOmitInterviewerQuestions(true);
    }
  },
  methods: {
    updateOmitInterviewerQuestions(value) {
      this.omitInterviewerQuestions = value;
    },
    async interviewPlayed() {
      this.$emit('play');
      if (!this.interview.viewed) {
        const data = await response(Interview.api().update(this.interview.id, { viewed: true }));
        this.interview = Interview.query().find(data.id);
      }
    },
  },
};
</script>

<style scoped>
.questions-list {
  overflow-y: auto;
}
</style>

<i18n locale="en" lang="yaml">
  skipQuestionListening: Skip questions
</i18n>

<i18n locale="ru" lang="yaml">
  skipQuestionListening: Пропускать прослушивание вопроса
</i18n>
